exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#signature{border-radius:5px;background-image:linear-gradient(#fff,#fff),radial-gradient(circle at top left,#4bc5e8,#9f6274);background-origin:border-box;background-clip:content-box,border-box}.container{width:100%;padding:8px 16px}.buttons{display:flex;gap:8px;justify-content:center;margin-top:8px}", ""]);

// exports
